import * as angular from 'angular';
import { createDisplayConditionDirective } from './displayCondition/create/create.directive';
import { conditionTreeDirective } from './displayCondition/details/conditionTree/conditionTree.directive';
import { fieldReferenceDirective } from './displayCondition/details/fieldReference/fieldReference.directive';
import { valueListDirective } from './displayCondition/details/valueList/valueList.directive';
import { displayDirective } from './displayCondition/display/display.directive';

angular
  .module('formApp')
  .directive('fdDisplayCondition', displayDirective)
  .directive('fdFieldReference', fieldReferenceDirective)
  .directive('fdValueList', valueListDirective)
  .directive('fdConditionTree', conditionTreeDirective)
  .directive('fdCreateDisplayCondition', createDisplayConditionDirective);
